import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@acorn-portal/shared/src/store';
import { PcRestartResponse } from '../services/subscriptionAPI';

interface SubscriptionState {
	policyToken: string | undefined;
	sendWelcomePackStatus: boolean | undefined;
	autoRenew: boolean | undefined;
	effectiveDate: string | undefined;
	quoteData: PcRestartResponse | undefined;
}

const INITIAL_STATE: SubscriptionState = {
	policyToken: undefined,
	sendWelcomePackStatus: undefined,
	effectiveDate: undefined,
	autoRenew: undefined,
	quoteData: undefined,
};

const subscriptionSlice = createSlice({
	name: 'subscription',
	initialState: INITIAL_STATE,
	reducers: {
		setSubscriptionData(state, action: PayloadAction<SubscriptionState>) {
			return {
				...state,
				...action.payload,
			};
		},
		updateSubscriptionData(state, action: PayloadAction<SubscriptionState>) {
			return { ...state, ...action.payload };
		},
		resetSubscriptionData() {
			return INITIAL_STATE;
		},
		updateNoClaimsProtection(state, action: PayloadAction<{ protectNoClaimsBonus: boolean }>) {
			const { protectNoClaimsBonus } = action.payload;
			if (state.quoteData) {
				state.quoteData.quoteDetails.riskData.coverDetails.ncdRequirements.protectedNcd = protectNoClaimsBonus;
			}
		},
	},
});

export const { setSubscriptionData, updateSubscriptionData, resetSubscriptionData, updateNoClaimsProtection } =
	subscriptionSlice.actions;

export default subscriptionSlice.reducer;

export const selectSubscriptionData = (state: RootState) => state.subscription;

export type { SubscriptionState };
